






























/* General */
import Vue from 'vue'
import CardCanvas from '@/layouts/card-canvas.vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */
import ProfileAPI from '@/api/modules/profile.api'
import CardCanvasTwoDeepBreadcrumb from '@/components/global/breadcrumb/card-canvas-two-deep-breadcrumb.vue'

export default Vue.extend({
  components: {
    CardCanvas,
    CardCanvasTwoDeepBreadcrumb,
  },
  metaInfo: {
    title: 'Webhooks',
  },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      webhooksManagementUrl: '',
    }
  },

  async created() {
    await this.fetchWebhooksManagementUrl()
  },

  methods: {
    async fetchWebhooksManagementUrl() {
      this.isLoading = true
      try {
        const response = await ProfileAPI.get_OutboundWebhooksManagementUrl()
        this.webhooksManagementUrl = response.url
      } catch (error) {
        this.$error.emit(error)
      } finally {
        this.isLoading = false
      }
    },
  },
})
